import { restApiClient } from '@/datasources';
import { OpenPayment } from '@/types/open-payment.types';

export const OPEN_INVOICES_ENDPOINT = '/online/open-invoices';

export async function getOpenPayments(signal?: AbortSignal): Promise<OpenPayment[]> {
  const { data } = await restApiClient.get<OpenPayment[] | undefined>(
    OPEN_INVOICES_ENDPOINT,
    undefined,
    { signal },
  );

  return data ?? [];
}
